import type {
  ISupplierDocument,
  ISupplierUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createSupplierDocument,
  updateDocument: updateSupplierDocument,
  deleteDocument: deleteSupplierDocument,
} = makeDocumentService<ISupplierDocument, ISupplierUploadDocument>(
  '/api/supplierdocuments',
  'supplierDocument'
)
